import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { IntlProvider } from 'react-intl';
import LangController from './lang-controller/lang-controller';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const locale = navigator.language;
const lang = LangController();

root.render(
  <React.StrictMode>
    <IntlProvider locale ={locale} messages={lang}>
      <App /> 
    </IntlProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
